import React, { createContext, useContext } from 'react';
import useTScoreHook from '../../hooks/Dashboard/useTScore';

export const TSContext = createContext();

export const TSProvider = ({ children }) => {
  const data = useTScoreHook();

  return (
    <TSContext.Provider value={data}>
      {children}
    </TSContext.Provider>
  );
};

export const useTSContext = () => useContext(TSContext);